module.exports = __webpack_public_path__ + "static/media/logo_dev.b5b74af6.png";